export default "__VITE_ASSET__CAw2bC6K__"